import { render, staticRenderFns } from "./ColaboracoesAprovadas.vue?vue&type=template&id=5c8fdae2&scoped=true"
import script from "./ColaboracoesAprovadas.vue?vue&type=script&lang=js"
export * from "./ColaboracoesAprovadas.vue?vue&type=script&lang=js"
import style0 from "./ColaboracoesAprovadas.vue?vue&type=style&index=0&id=5c8fdae2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8fdae2",
  null
  
)

export default component.exports